/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class e extends r{constructor(r,e,o){super(r,"vec4",0,(s,t)=>s.setUniform4fv(r,e(t),o))}}export{e as Float4BindUniform};
